var map = {
	"./ar/nav_bar_desc.json": "0e26",
	"./en/nav_bar_desc.json": "1260",
	"./es/nav_bar_desc.json": "ca6f",
	"./fr/nav_bar_desc.json": "e15a",
	"./ht/nav_bar_desc.json": "8c05",
	"./pt/nav_bar_desc.json": "46bd",
	"./ru/nav_bar_desc.json": "314d",
	"./sw/nav_bar_desc.json": "921e",
	"./vi/nav_bar_desc.json": "1f28",
	"./zh/nav_bar_desc.json": "c158"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "93c7";